import { defineStore } from 'pinia'
import axios from 'axios'

export const useInsightsHiringStore = defineStore('insightsHiring', {
  state: () => ({
    contracted: false,
    popupOpen: false,
    pendingRoute: null,
    loading: false,
    alreadyFetched: false
  }),

  actions: {
    async fetchStatus(force = false) {
      if (this.loading) return

      if (this.alreadyFetched && !force) return

      this.loading = true

      try {
        const { data } = await axios.get('/api/assistents/resources/insights-status')

        this.contracted = !!data?.contracted
        this.alreadyFetched = true
      } catch (error) {
        console.error(error)

        this.contracted = false
        this.alreadyFetched = true
      } finally {
        this.loading = false
      }
    },

    openPopup(route = null) {
      this.pendingRoute = route
      this.popupOpen = true
    },

    closePopup() {
      this.popupOpen = false
    },

    async markAsHired() {
      await this.fetchStatus(true)

      this.popupOpen = false
    },

    async accessInsights(router, targetRoute = '/model') {
      await this.fetchStatus()

      if (!this.contracted) {
        this.openPopup(targetRoute)
        return
      }

      router.push(targetRoute)
    },

    redirectAfterHiring(router, fallbackRoute = '/model') {
      const routeToGo = this.pendingRoute || fallbackRoute

      this.pendingRoute = null
      this.popupOpen = false

      router.push(routeToGo)
    }
  }
})
